import { render } from "./PlacetelCalls.vue?vue&type=template&id=d4934524"
import script from "./PlacetelCalls.vue?vue&type=script&lang=js"
export * from "./PlacetelCalls.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__